"use strict";import{SplitView as e}from"./src/SplitView.js";import{defineElement as i}from"@spectrum-web-components/base/src/define-element.js";i("sp-split-view",e);
//# sourceMappingURL=sp-split-view.js.map
